module.exports = __webpack_public_path__ + "media/components/trial/common/statics/raion-ee4c3a7b08ea9748d13ba554418f21b1.png";